import { RestQuery, QueryAgg, QuerySort, QueryColumn, QueryParams, PageData } from './restquery';
import { SortDir, DataAgg } from '../meta/basetype';

export class QueryBuilder {
  first = 0;
  rows = 0;
  orderBy = '';
  limit = 0;
  aggregate: QueryAgg[];
  sort: QuerySort[];
  search: QueryParams;
  columns: QueryColumn[];

  static get(): QueryBuilder {
    return new QueryBuilder();
  }
  static buildPage<T>(datas: T[]): PageData<T> {
    return {
      first: 1,
      rows: datas.length,
      datas,
      total: datas.length
    };
  }

  getQueryInfo(): RestQuery {
    return {
      first: this.first,
      rows: this.rows,
      orderBy: this.orderBy,
      limit: this.limit,
      aggregate: this.aggregate,
      sort: this.sort,
      search: this.search,
      columns: this.columns
    };
  }

  setPage(first: number, size: number): this {
    this.first = first;
    this.rows = size;
    return this;
  }

  setLimit(limit: number): this {
    this.limit = limit;
    return this;
  }

  setOrder(orderBy: string): this {
    this.orderBy = orderBy;
    return this;
  }

  addSort(field: string, dir?: SortDir): this {
    if (!this.sort) {
      this.sort = [];
    }
    this.sort.push({ field, dir });
    return this;
  }

  /**
   * æ·»å å°è®¡ï¼ç¨äºåè¡¨Footeråè®¡ï¼
   */
  addAgg(propName: string, agg: DataAgg): this {
    if (!this.aggregate) {
      this.aggregate = [];
    }
    this.aggregate.push({ field: propName, aggregate: agg });
    return this;
  }

  addParam(paramName: string, paramVal: any): this {
    if (!this.search) {
      this.search = {};
    }
    this.search[paramName] = paramVal;
    return this;
  }
  addColunm(field: string, alias?: string, agg?: DataAgg): this {
    if (!this.columns) {
      this.columns = [];
    }
    this.columns.push({ propName: field, field: alias, agg: agg });
    return this;
  }
  /**
   * @description shortcut for group
   *
   */
  groupby(field: string, alias?: string): this {
    return this.addColunm(field, alias);
  }
  sum(field: string, alias?: string): this {
    return this.addColunm(field, alias ? alias : ('sum_' + field), DataAgg.sum);
  }
  avg(field: string, alias?: string): this {
    return this.addColunm(field, alias ? alias : ('avg_' + field), DataAgg.avg);
  }
  count(field: string, alias?: string): this {
    return this.addColunm(field, alias ? alias : ('cnt_' + field), DataAgg.count);
  }
  min(field: string, alias?: string): this {
    return this.addColunm(field, alias ? alias : ('min_' + field), DataAgg.min);
  }
  max(field: string, alias?: string): this {
    return this.addColunm(field, alias ? alias : ('max_' + field), DataAgg.max);
  }

  addQueryInfo(qi: RestQuery): this {
    if (!qi) { return this; }

    if (qi.first != null) { this.first = qi.first; }
    if (qi.rows != null) { this.rows = qi.rows; }
    if (qi.limit != null) { this.limit = qi.limit; }
    if (qi.orderBy != null) { this.orderBy = qi.orderBy; }
    if (qi.sort) {
      for (const st of qi.sort) {
        this.addSort(st.field, st.dir);
      }
    }
    if (qi.aggregate) {
      for (const agg of qi.aggregate) {
        this.addAgg(agg.field, agg.aggregate);
      }
    }
    if (qi.search) {
      // tslint:disable-next-line:forin
      for (const prop in qi.search) {
        this.addParam(prop, qi.search[prop]);
      }
    }
    if (qi.columns) {
      if (Array.isArray(qi.columns)) {
        qi.columns.forEach(col => this.addColunm(col.propName, col.field, col.agg));
      } else {
        const cols = qi.columns.split(';');
        cols.forEach(col => {
          const tmp = col.split('=');
          this.addColunm(tmp[0], tmp.length > 1 ? tmp[1] : null);
        });
      }
    }
    return this;
  }

}
